<template>
  <button
    :aria-expanded="isExpanded ? 'true' : 'false'"
    class="nav-toc__toggle"
    :class="{
      'nav-toc__toggle--is-expanded': internalIsExpanded,
    }"
    @click="toggle"
  >
    <span
      class="nav-toc__icon"
      :class="{
        'nav-toc__icon--close': isExpanded,
        'nav-toc__icon--open': !isExpanded,
      }"
    >
      <a-label :path="isExpanded ? 'dossier.close' : 'dossier.open'" />
    </span>
  </button>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  inject: ['context', 'toggle', 'registerToggleEl'],
  data() {
    return {
      internalIsExpanded: false,
    };
  },
  computed: {
    ...mapGetters({
      breakpointUp: 'window/breakpointUp',
    }),
    isExpanded() {
      return this.context.isExpanded;
    },
  },
  watch: {
    isExpanded(isExpanded) {
      if (isExpanded) {
        this.internalIsExpanded = true;
        return;
      }

      setTimeout(() => {
        this.internalIsExpanded = false;
      }, 400);
    },
  },
  mounted() {
    this.registerToggleEl(this.$el);
  },
  methods: {
    scrollIntoView() {
      if (this.breakpointUp('sm')) return;
      this.$el.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start',
      });
    },
  },
};
</script>
